import { render, staticRenderFns } from "./AnimateHeading.vue?vue&type=template&id=b85b9a12&"
import script from "./AnimateHeading.vue?vue&type=script&lang=ts&"
export * from "./AnimateHeading.vue?vue&type=script&lang=ts&"
import style0 from "./AnimateHeading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports